module.exports = __webpack_public_path__ + "img/share.9a3c61c1.png";